import React from 'react'
import '../css/header.css'
import '../css/AppHeader.css'
import '../css/common.css'
import logo from '../static-contents/Target_logo_white.png'

// Renders page header
const AppHeader = ({ onLogout, isAuthenticated }) => {
  return (
    <div className="app-header">
      {/* Show header on desktop, hidden on mobile via CSS */}
      <ul className="app-header__nav" id="nav">
        <li className="app-header__logo-container">
          <img src={logo} alt="logofile" className="app-header__logo" />
          <p className="app-header__title">Guest Wi-Fi Authentication</p>
        </li>

        {/* Only show Logout if authenticated */}
        {isAuthenticated && (
          <li className="app-header__logout-container">
            <button onClick={onLogout} className="app-header__logout-button">
              Logout
            </button>
          </li>
        )}
      </ul>
    </div>
  )
}

export default AppHeader
